export { default as Keyin } from './screens/Keyin';
export { default as Uploadfile } from './screens/Uploadfile';
export { default as Api } from './screens/Api';
export { default as Approve } from './screens/Approve';
export { default as Detail } from './screens/Detail';
